import { defineMessages } from 'react-intl';

export const uspsMessagesKeys = [
  'payHowYouWant',
  'freeExchanges',
  'thirtyDayReflectionPeriod',
  'deliveredFromSupplier',
  'homeDeliveryToFrontDoor',
  'twoYearWarranty',
  'oldElectricalAppliance',
  'customersRateService',
  'weConnectToWater',
  'transportBoltsAreRemoved',
  'homeDeliveryAtPoint',
];

export const uspsMessages = defineMessages<(typeof uspsMessagesKeys)[number]>({
  payHowYouWant: {
    id: 'usps.payHowYouWant',
    defaultMessage: '<bold>Betaal zoals je wilt:</bold> vooraf, achteraf of in termijnen',
  },
  freeExchanges: {
    id: 'usps.freeExchanges',
    defaultMessage: '<bold>Gratis</bold> ruilen',
  },
  thirtyDayReflectionPeriod: {
    id: 'usps.thirtyDayReflectionPeriod',
    defaultMessage: '30 dagen <bold>bedenktijd</bold>',
  },
  deliveredFromSupplier: {
    id: 'usps.deliveredFromSupplier',
    defaultMessage: '<bold>Rechtstreeks</bold> vanuit de leverancier bezorgd',
  },
  homeDeliveryToFrontDoor: {
    id: 'usps.homeDeliveryToFrontDoor',
    defaultMessage: '<bold>Thuisbezorgd tot</bold> de voordeur op de begane grond',
  },
  twoYearWarranty: {
    id: 'usps.twoYearWarranty',
    defaultMessage: '2 jaar <bold>garantie</bold>',
  },
  oldElectricalAppliance: {
    id: 'usps.oldElectricalAppliance',
    defaultMessage: 'We nemen je oude elektrische apparaat <bold>gratis</bold> mee',
  },
  customersRateService: {
    id: 'usps.customersRateService',
    defaultMessage: 'Klanten geven onze bezorgservice <bold>een 8,3</bold>',
  },
  weConnectToWater: {
    id: 'usps.weConnectToWater',
    defaultMessage: 'We <bold>sluiten aan op water/elektra</bold> en zetten waterpas',
  },
  transportBoltsAreRemoved: {
    id: 'usps.transportBoltsAreRemoved',
    defaultMessage: 'Transportbouten worden verwijderd',
  },
  homeDeliveryAtPoint: {
    id: 'usps.homeDeliveryAtPoint',
    defaultMessage: 'Thuisbezorgd of bij PostNL Punt',
  },
});
